export const CREATE_VALET = 'add_valet';
export const UPDATE_VALET_STATUS = 'update_valet_status'
export const TAG_CREATION = 'tag_creation'
export const TAG_LIST = 'tag_list'